import { usePrevious } from 'src/utils/hooks/usePrevious';

/**
 * Type-inferring hook for determining whether the previous instance of any value
 * has changed from its current value (e.g. comparing props/state with prevProps/prevState).
 *
 * @returns whether the previous value is not equal to the current value
 */
export const useDidValueChange = <T>(
  value: T,
  equalityFn: (val: T, prevVal: T) => boolean = (val, prevVal) =>
    val === prevVal
): boolean => {
  const prevValue = usePrevious(value);
  return prevValue === undefined ? true : !equalityFn(value, prevValue);
};
